import colors from '../../../../constants/colors';

const ACCOUNT_STATE = {
  APPLYING: 'APPLYING',
  REJECTED: 'REJECTED',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  UNKNOWN: 'UNKNOWN'
};

const ACCOUNT_STATE_MAP = {
  [ACCOUNT_STATE.APPLYING]: {
    text: 'Applying',
    color: colors.warning
  },
  [ACCOUNT_STATE.REJECTED]: {
    text: 'Rejected',
    color: colors.error
  },
  [ACCOUNT_STATE.ACTIVE]: {
    text: 'Active',
    color: colors.success
  },
  [ACCOUNT_STATE.INACTIVE]: {
    text: 'Inactive',
    color: colors.error
  },
  [ACCOUNT_STATE.UNKNOWN]: {
    text: 'Unknown',
    color: colors.warning
  }
};

const LOCKED_STATE = {
  NORMAL: 'NORMAL',
  LOCKED: 'LOCKED'
};

const LOCKED_STATE_MAP = {
  [LOCKED_STATE.NORMAL]: {
    text: 'Normal',
    color: colors.success
  },
  [[LOCKED_STATE.LOCKED]]: {
    text: 'Locked',
    color: colors.warning
  }
};

const PASSWORD_STATE = {
  ACTIVE: 'ACTIVE',
  EXPIRED: 'EXPIRED'
};

const PASSWORD_STATE_MAP = {
  [PASSWORD_STATE.ACTIVE]: {
    text: 'Active',
    color: colors.success
  },
  [PASSWORD_STATE.EXPIRED]: {
    text: 'Expired',
    color: colors.warning
  }
};

export {
  ACCOUNT_STATE,
  ACCOUNT_STATE_MAP,
  LOCKED_STATE_MAP,
  PASSWORD_STATE_MAP
};
